import moment from 'moment';
import { DoctorService } from '@/services/doctor.service';
export default {
  props: {
    reassignmentType: {
      type: String,
      default: 'TEMPORARY'
    },
    sourceDoctorLabel: {
      type: String,
      default: ''
    },
    startTimestamp: {
      type: Number,
      default: null
    },
    endTimestamp: {
      type: Number,
      default: null
    },
    reasonLabel: {
      type: String,
      default: ''
    },
    statesCount: {
      type: Number,
      default: 0
    },
    doctorsCount: {
      type: Number,
      default: 0
    },
    totalToTransfer: {
      type: Number,
      default: 0
    },
    submitBody: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showDialog: false,
      submitting: false,
      alert: {
        show: false,
        message: ''
      }
    };
  },
  computed: {
    isTemporary() {
      return this.reassignmentType === 'TEMPORARY';
    },
    formattedStart() {
      return this.startTimestamp ? moment.unix(this.startTimestamp).format('MMM D, YYYY h:mm A') : '—';
    },
    formattedEnd() {
      return this.endTimestamp ? moment.unix(this.endTimestamp).format('MMM D, YYYY h:mm A') : '—';
    },
    effectiveWindowLabel() {
      return this.isTemporary ? `${this.formattedStart} → ${this.formattedEnd}` : this.formattedStart;
    }
  },
  methods: {
    async confirmTransfer() {
      if (this.submitting) {
        return;
      }
      this.submitting = true;
      try {
        await DoctorService.submitAdhocReassignment(this.submitBody);
        this.showDialog = false;
        this.$emit('submitted');
      } catch {
        this.alert = {
          show: true,
          message: 'Failed to submit reassignment. Please try again.'
        };
      } finally {
        this.submitting = false;
      }
    },
    onHide() {
      this.alert = {
        show: false,
        message: ''
      };
      this.submitting = false;
    }
  }
};